import React from 'react';
import { getIn } from 'seamless-immutable';
import styled from 'styled-components';
import ProductTooltip from '@catalogo/ui-americanas-mobile-product-tooltip';
import { Nav } from '@catalogo/core-nav';
import Badge from './badge';

class Badges extends React.Component {
  render() {
    const { currentSku, product } = this.props;
    const hasUsed = getIn(currentSku, ['offers', 'result', 0, 'condition']) === 'USED';
    const isInternational = getIn(currentSku, ['offers', 'result', 0, 'currency']) === 'USD';
    const isRecommended = currentSku?.offers?.result?.[0]?.stamps?.result?.includes('INDICA') || false;
    const hasPreSale = getIn(product, ['isPreSale']);
    const isDigital = getIn(product, ['isDigital']);

    if (isRecommended || hasUsed || isInternational || hasPreSale || isDigital) {
      return (
        <Grid>
          {isRecommended && (
            <Badge
              svg="icon-brand"
              svgColor="#f80032"
              background="#eee"
              content="indica"
              spacingTop
              textColor="#333"
              spacingRight
              svgHeight="15"
            />
          )}

          {isDigital && (
            <ProductTooltip openTooltipWith={['div', 'span']} startOpen={true}>
              <Badge background="#eee" content="entrega digital" textColor="#333" spacingRight />
              <TextUI>
                <Strong>É tudo por e-mail:</Strong> a gente envia as informações e explica como usar. Liberamos o
                produto para uso em <Strong>até 1h</Strong> depois da aprovação do pagamento, tá?{' '}
                <NavUI to="#modal-digital-delivery">saiba mais</NavUI>
              </TextUI>
            </ProductTooltip>
          )}

          {hasUsed && <Badge background="#eee" content="usado" textColor="#333" spacingRight />}

          {hasPreSale && <Badge background="#eee" content="pré-venda" textColor="#333" spacingRight />}

          {isInternational && (
            <Badge
              svg="icon-airplane"
              svgColor="#f80032"
              background="#eee"
              content="produto internacional"
              textColor="#333"
              spacingRight
            />
          )}
        </Grid>
      );
    }

    return null;
  }
}

const Grid = styled.div`
  display: flex;
  flex-direction: row;
`;

const TextUI = styled.p`
  font-size: 14px;
`;

const NavUI = styled(Nav)`
  text-decoration: underline;
`;

const Strong = styled.strong`
  color: #333;
`;

export default Badges;
